import isAbsoluteUrl from 'is-absolute-url';
import * as React from 'react';
export default {
  isAbsoluteUrl,
  React
};